import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "5",
  height: "21",
  viewBox: "0 0 5 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 0h5v5H0zm0 8h5v5H0zm0 8h5v5H0z" }, null, -1)
  ]))]))
}
export default { render: render }